import { Alert, Button, Space, Typography } from 'antd'
import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { queryKeys } from '@/shared/api/queryKeys'
import { usePermissions } from '@/shared/auth/usePermissions'
import { shortId } from '@/shared/lib/shortId'
import { fetchAgent } from '@/features/agent/agentApi'
import { fetchSubscriber } from '@/features/subscriber/subscriberApi'

interface JournalOwnerBannerProps {
  ownerType: string
  ownerId: string
  onClear: () => void
}

const AGENT_TYPES = ['AGENT', 'RESELLER']

/**
 * «Qaysi egannikini ko'ryapman» — ochiq aytiladigan javob.
 *
 * <h2>⚠️ NEGA BU BANNER KERAK</h2>
 * Abonent kartasidagi «To'lovlari» havolasi bu sahifani
 * `ownerType=SUBSCRIBER&ownerId=<uuid>` bilan ochadi. Filtr esa panelning
 * ichida — voronka nishoni ostida. Ya'ni operator TO'LIQ ro'yxat deb
 * o'ylagan ekranda aslida BITTA abonentning yozuvlari turardi va bu
 * «nega bunchalik kam tranzaksiya bo'ldi?» degan javobsiz savolni
 * tug'dirardi.
 *
 * <h2>⚠️ NOM — SO'ROV BILAN, XOM UUID BILAN EMAS</h2>
 * `ownerId` polimorfik UUID: jurnal moduli abonent yoki agent jadvaliga
 * `JOIN` qilmaydi (ADR-016), ya'ni nomni faqat o'sha modulning O'Z
 * endpointi biladi. Huquq yetmasa so'rov UMUMAN yuborilmaydi (403 sikli
 * yo'q) va qisqartirilgan id ko'rsatiladi — «noma'lum» EMAS: id bor,
 * shunchaki nomini ko'rish huquqi yo'q.
 */
export function JournalOwnerBanner({ ownerType, ownerId, onClear }: JournalOwnerBannerProps) {
  const { t } = useTranslation()
  const { can } = usePermissions()

  const isSubscriber = ownerType === 'SUBSCRIBER'
  const isAgent = AGENT_TYPES.includes(ownerType)

  const subscriber = useQuery({
    queryKey: queryKeys.subscribers.detail(ownerId),
    queryFn: () => fetchSubscriber(ownerId),
    enabled: isSubscriber && can('subscriber.read'),
    staleTime: 5 * 60_000,
  })

  const agent = useQuery({
    queryKey: queryKeys.agents.detail(ownerId),
    queryFn: () => fetchAgent(ownerId),
    enabled: isAgent && can('agent.read'),
    staleTime: 5 * 60_000,
  })

  const name = subscriber.data?.login ?? agent.data?.displayName ?? null

  return (
    <Alert
      type="info"
      showIcon
      style={{ marginBottom: 16 }}
      message={
        <Space size={6} wrap>
          <span>{t(`ledgerOwnerType.${ownerType}`, { defaultValue: ownerType })}:</span>
          {name === null ? (
            <Typography.Text code copyable={{ text: ownerId }}>
              {shortId(ownerId)}
            </Typography.Text>
          ) : (
            <Typography.Text strong>{name}</Typography.Text>
          )}
        </Space>
      }
      description={t('ledgerJournal.ownerFilterHint')}
      action={
        <Button size="small" onClick={onClear}>
          {t('ledgerJournal.clearOwnerFilter')}
        </Button>
      }
    />
  )
}
